module.exports = __webpack_public_path__ + "img/img_func_top.fcf994b5.png";